// import { useToast } from "@chakra-ui/react";
import { functions } from "connections/firebase";
import { httpsCallable } from "firebase/functions";
import { IDoorLock } from "interfaces/device";

interface IGetInstalledDoorLockResponse {
  list: IDoorLock[];
  total: number;
}

interface IGrantLockPayload {
  userId: string;
  lockId: number;
}

export default function useDoorLock() {
  // const toast = useToast();
  const getInstalledDoorLock = httpsCallable<
    null,
    IGetInstalledDoorLockResponse
  >(functions, "getInstalledDoorLock");

  const grantLockFunction = httpsCallable<IGrantLockPayload>(
    functions,
    "grantLock"
  );

  const getDoorLockList = async () => {
    const response = await getInstalledDoorLock();
    if (response.data) {
      return response.data.list;
    } else {
      return [];
    }
  };

  const grantLock = async (params: IGrantLockPayload) => {
    const response = await grantLockFunction(params);
    console.log(response);
  };

  return {
    getDoorLockList,
    grantLock,
  };
}
